import ServiceBusController from "servicestack/service-bus.controller";
import CartItem from "emun.cart/cart-item.model";
import labels from "emun.order/_labels";
import sendEmailPrompt from "servicestack/email/send-email-prompt";
import resolve from "ioc/resolve";
import shoppingConfig from "emun.shopping/shopping.config";
import cartConfig from "emun.cart/cart.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import OrderQuestionsPrompt from "emun.cart/order-questions-prompt";

export default class GuestCheckoutController extends ServiceBusController {
  constructor($window) {
    super($window);
    const $ctrl = this;
    $ctrl.$window = $window;
  }
  cacheBusterGuid() {
    return "&cacheBuster=xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  $onInit() {
    const $ctrl = this;
    basicController($ctrl);
    const $rootScope = resolve("$rootScope");
    $ctrl.labels = labels;
    $ctrl.shoppingConfig = shoppingConfig;
    $ctrl.cartConfig = cartConfig;
    $ctrl.loading = false;
    $ctrl.months = $rootScope.$dates.monthNumbers; // Needed???
    $ctrl.years = $rootScope.$dates.getYears(); // Needed???
    $ctrl.paymentMethod = {};
    $ctrl.swipe = $ctrl.shoppingConfig.defaultSwipeCC;
    $ctrl.retailerId = "";
  }
  lookupOrder() {
    const $ctrl = this;
    $ctrl.loading = new Date();
    $ctrl.noresults = false;
    $ctrl.bus
      .send(`Cart/${$ctrl.cartId}.json?IncludeProducts=1&Token=GUESTCHECKOUT`)
      .then((cr) => {
        if (cr.data.results.length) {
          const [{ items, ...cart }] = cr.data.results;
          $ctrl.cart = cart;
          $ctrl.retailerId = $ctrl.cart.purchaser.id || $ctrl.cart.retailerId;
          $ctrl.items = items;
          $ctrl.noresults = false;
          // $ctrl.printUrl = $appConfig.serviceUrl + "SalesOrderPrint/" + $ctrl.cartId + "?OutputType=PortableDocFormat" + $ctrl.cacheBusterGuid();
          // $ctrl.printImagesUrl = $appConfig.serviceUrl + "SalesOrderPrint/" + $ctrl.cartId + "?OutputType=PortableDocFormat&IncludeImages=True" + $ctrl.cacheBusterGuid();
          if (
            $ctrl.cart &&
            $ctrl.cart.status !== "On Hold" &&
            $ctrl.cart.reasonCode !== "Credit Card" &&
            $ctrl.cart.id &&
            !$ctrl.submitted
          ) {
            $ctrl.$state.go("selfcheckout-confirmation", {
              cart: $ctrl.cartId,
              orderNumber: $ctrl.cartId,
            });
          }
        } else {
          $ctrl.noresults = true;
          var element = $ctrl.$window.document.getElementById("orderid");
          if (element) {
            element.focus();
          }
        }
      })
      .finally(() => {
        $ctrl.loading = false;
      });
  }
  reset() {
    const $ctrl = this;
    $ctrl.cart.id = "";
    $ctrl.cartId = "";
    $ctrl.retailerId = "";
  }
  complete() {
    const $ctrl = this;
    $ctrl.bus.send("GetShowSettings.json").then((res) => {
		$ctrl.showSettings = res.data;
		let request = {
			id: $ctrl.cartId
		}
		if ($ctrl.cartConfig.enableShowroomAutoPrint && $ctrl.showSettings.defaultPrinter) {
			request.printer = $ctrl.showSettings.defaultPrinter;
			request.printWithImages = $ctrl.showSettings.defaultOrderPrintIncludeImages;
			request.numCopies = $ctrl.showSettings.orderCopiesToPrint || 1;
		}
		$ctrl.bus
		.send("SubmitCart.json", request)
		.then(function (res) {
		  $ctrl.$state.go("selfcheckout-confirmation", {
			cart: $ctrl.cartId,
			orderNumber: $ctrl.cartId,
		  });
		  // if ($ctrl.cartConfig.askQuestions) {
			// return OrderQuestionsPrompt({
			//   //subTitle: cart.purchaser.id,
			//   id: $ctrl.cartId,
			//   retailerId: $ctrl.retailerId,
			// });
		  // } else {
			$ctrl.$cart.reset();
			$ctrl.submitted = false;
			$ctrl.cartId = "";
			$ctrl.cart.id = "";
			$ctrl.retailerId = "";
		  // }
		});
	});

  }
  hold() {
    const $ctrl = this;
    $ctrl.bus
      .send("HoldCart.json", {
        id: $ctrl.cartId,
        cartName: $ctrl.cart.cartName,
      })
      .then(function (res) {
        $ctrl.$cart.reset();
        $ctrl.submitted = false;
        $ctrl.cartId = "";
        $ctrl.cart.id = "";
        $ctrl.retailerId = "";
      });
  }
  saveCard() {
    let $ctrl = this;
    //$ctrl.paymentMethod.name = $ctrl.paymentMethod.companyName = $ctrl.purchaser.companyName;
    $ctrl.paymentMethod.isPrimary = true;
    $ctrl.paymentMethod.retailerId =
      $ctrl.cart.purchaser.id || $ctrl.cart.retailerId;
    $ctrl.paymentMethod.expiration =
      $ctrl.paymentMethod.expirationMonth.toString() +
      $ctrl.paymentMethod.expirationYear.toString();
    $ctrl.paymentMethod.expiresOn =
      $ctrl.paymentMethod.expirationMonth +
      "/1/" +
      $ctrl.paymentMethod.expirationYear;
    $ctrl.paymentMethod.cartId = $ctrl.cart.id;
    $ctrl.bus
      .validate("ApplyPaymentMethod.json", $ctrl.paymentMethod)
      .then(function (res) {
        $ctrl
          .applyPaymentMethod($ctrl.paymentMethod, $ctrl.cart.id)
          .then(function (response) {
            $ctrl.bus
              .send(
                `Cart/${$ctrl.cartId}.json?IncludeProducts=1&Token=${$ctrl.token}`
              )
              .then((cr) => {
                if (cr.data.results.length) {
                  const [{ items, ...cart }] = cr.data.results;
                  $ctrl.cart = cart;
                  $ctrl.items = items;
                }
              })
              .finally(() => {
                $ctrl.loading = false;
              });
          });
      });
  }

  toggleSameAsCorporate() {
    let $ctrl = this;
    if ($ctrl.sameAsCorporate) {
      $ctrl.paymentMethod.address =
        $ctrl.cart.purchaser.address || $ctrl.cart.billingLocation.address;
      $ctrl.paymentMethod.address2 =
        $ctrl.cart.purchaser.address2 || $ctrl.cart.billingLocation.address2;
      $ctrl.paymentMethod.city =
        $ctrl.cart.purchaser.city || $ctrl.cart.billingLocation.city;
      $ctrl.paymentMethod.state =
        $ctrl.cart.purchaser.state || $ctrl.cart.billingLocation.state;
      $ctrl.paymentMethod.zip =
        $ctrl.cart.purchaser.zip || $ctrl.cart.billingLocation.zip;
      $ctrl.paymentMethod.country =
        $ctrl.cart.purchaser.country || $ctrl.cart.billingLocation.country;
    }
  }

  applyPaymentMethod(paymentMethod, cartId) {
    const $ctrl = this;
    if (!paymentMethod.address) {
      paymentMethod.address =
        $ctrl.cart.billingLocation.address ||
        $ctrl.cart.shippingLocation.address;
    }
    if (!paymentMethod.address2) {
      paymentMethod.address2 =
        $ctrl.cart.billingLocation.address2 ||
        $ctrl.cart.shippingLocation.address2;
    }
    if (!paymentMethod.city) {
      paymentMethod.city =
        $ctrl.cart.billingLocation.city || $ctrl.cart.shippingLocation.city;
    }
    if (!paymentMethod.state) {
      paymentMethod.state =
        $ctrl.cart.billingLocation.state || $ctrl.cart.shippingLocation.state;
    }
    if (!paymentMethod.zip) {
      paymentMethod.zip =
        $ctrl.cart.billingLocation.zip || $ctrl.cart.shippingLocation.zip;
    }

    let request = Object.assign(
      { cartId: cartId || $ctrl.cart.id },
      paymentMethod
    );
    request.phone = (request.phone || "").replace(/\D/gi, "");
    if (
      paymentMethod.personName &&
      paymentMethod.personName.full &&
      !paymentMethod.name
    ) {
      request.name = paymentMethod.personName.full;
    }
    request.fullName = request.name;
    request.personName = { full: request.name };
    $ctrl.submitting = new Date();
    return $ctrl.bus.send("ApplyPaymentMethod.json", request).then(
      (res) => {
        $ctrl.done = res.data;
        $ctrl.submitting = false;
        $ctrl.submitted = new Date();
      },
      (res) => {
        $ctrl.failed = res.data;
        $ctrl.submitting = false;
      }
    );
  }

  toggleSwipe() {
    let $ctrl = this;
    $ctrl.swipe = !$ctrl.swipe;
    $ctrl.hdnSwipeData = "";
  }

  ParseParserObj() {
    let $ctrl = this;
    $ctrl.swipe = false;
    $ctrl.SwipeParserObj($ctrl.hdnSwipeData);
    $ctrl.saveCard();
  }

  SwipeParserObj(strParse) {
    let $ctrl = this;
    ///////////////////////////////////////////////////////////////
    ///////////////////// member variables ////////////////////////
    $ctrl.input_trackdata_str = strParse;
    $ctrl.paymentMethod.name = null;
    $ctrl.surname = null;
    $ctrl.firstname = null;
    $ctrl.paymentMethod.number = null;
    $ctrl.paymentMethod.expirationMonth = null;
    $ctrl.paymentMethod.expirationYear = null;
    $ctrl.track1 = null;
    $ctrl.track2 = null;
    $ctrl.hasTrack1 = false;
    $ctrl.hasTrack2 = false;
    /////////////////////////// end member fields /////////////////

    $ctrl.sTrackData = $ctrl.input_trackdata_str; //--- Get the track data

    //-- Example: Track 1 & 2 Data
    //-- %B1234123412341234^CardUser/John^030510100000019301000000877000000?;1234123412341234=0305101193010877?
    //-- Key off of the presence of "^" and "="

    //-- Example: Track 1 Data Only
    //-- B1234123412341234^CardUser/John^030510100000019301000000877000000?
    //-- Key off of the presence of "^" but not "="

    //-- Example: Track 2 Data Only
    //-- 1234123412341234=0305101193010877?
    //-- Key off of the presence of "=" but not "^"

    if (strParse != "") {
      // alert(strParse);

      //--- Determine the presence of special characters
      $ctrl.nHasTrack1 = strParse.indexOf("^");
      $ctrl.nHasTrack2 = strParse.indexOf("=");

      //--- Set boolean values based off of character presence
      $ctrl.hasTrack1 = $ctrl.bHasTrack1 = false;
      $ctrl.hasTrack2 = $ctrl.bHasTrack2 = false;
      if ($ctrl.nHasTrack1 > 0) {
        $ctrl.hasTrack1 = $ctrl.bHasTrack1 = true;
      }
      if ($ctrl.nHasTrack2 > 0) {
        $ctrl.hasTrack2 = $ctrl.bHasTrack2 = true;
      }

      //--- Test messages
      // alert('nHasTrack1: ' + nHasTrack1 + ' nHasTrack2: ' + nHasTrack2);
      // alert('bHasTrack1: ' + bHasTrack1 + ' bHasTrack2: ' + bHasTrack2);

      //--- Initialize
      $ctrl.bTrack1_2 = false;
      $ctrl.bTrack1 = false;
      $ctrl.bTrack2 = false;

      //--- Determine tracks present
      if ($ctrl.bHasTrack1 && $ctrl.bHasTrack2) {
        $ctrl.bTrack1_2 = true;
      }
      if ($ctrl.bHasTrack1 && !$ctrl.bHasTrack2) {
        $ctrl.bTrack1 = true;
      }
      if (!$ctrl.bHasTrack1 && $ctrl.bHasTrack2) {
        $ctrl.bTrack2 = true;
      }

      //--- Test messages
      // alert('bTrack1_2: ' + bTrack1_2 + ' bTrack1: ' + bTrack1 + ' bTrack2: ' + bTrack2);

      //--- Initialize alert message on error

      //-----------------------------------------------------------------------------
      //--- Track 1 & 2 cards
      //--- Ex: B1234123412341234^CardUser/John^030510100000019301000000877000000?;1234123412341234=0305101193010877?
      //-----------------------------------------------------------------------------
      if ($ctrl.bTrack1_2) {
        //      alert('Track 1 & 2 swipe');

        $ctrl.strCutUpSwipe = "" + strParse + " ";
        $ctrl.arrayStrSwipe = new Array(4);
        $ctrl.arrayStrSwipe = $ctrl.strCutUpSwipe.split("^");

        var sAccountNumber, sName, sShipToName, sMonth, sYear;

        if ($ctrl.arrayStrSwipe.length > 2) {
          $ctrl.paymentMethod.number = stripAlpha(
            $ctrl.arrayStrSwipe[0].substring(1, $ctrl.arrayStrSwipe[0].length)
          );
          $ctrl.paymentMethod.name = $ctrl.arrayStrSwipe[1];
          $ctrl.paymentMethod.expirationMonth = parseInt(
            $ctrl.arrayStrSwipe[2].substring(2, 4)
          );
          $ctrl.paymentMethod.expirationYear = parseInt(
            "20" + $ctrl.arrayStrSwipe[2].substring(0, 2)
          );

          //--- Different card swipe readers include or exclude the % in the front of the track data - when it's there, there are
          //---   problems with parsing on the part of credit cards processor - so strip it off
          if ($ctrl.sTrackData.substring(0, 1) == "%") {
            $ctrl.sTrackData = $ctrl.sTrackData.substring(
              1,
              $ctrl.sTrackData.length
            );
          }

          var track2sentinel = $ctrl.sTrackData.indexOf(";");
          if (track2sentinel != -1) {
            $ctrl.track1 = $ctrl.sTrackData.substring(0, track2sentinel);
            $ctrl.track2 = $ctrl.sTrackData.substring(track2sentinel);
          }

          //--- parse name field into first/last names
          var nameDelim = $ctrl.paymentMethod.name.indexOf("/");
          if (nameDelim != -1) {
            $ctrl.surname = $ctrl.paymentMethod.name.substring(0, nameDelim);
            $ctrl.firstname = $ctrl.paymentMethod.name.substring(nameDelim + 1);
            $ctrl.paymentMethod.name =
              $ctrl.firstname.trim() + " " + $ctrl.surname.trim();
          }
        }
      }

      //-----------------------------------------------------------------------------
      //--- Track 1 only cards
      //--- Ex: B1234123412341234^CardUser/John^030510100000019301000000877000000?
      //-----------------------------------------------------------------------------
      if ($ctrl.bTrack1) {
        //      alert('Track 1 swipe');

        $ctrl.strCutUpSwipe = "" + strParse + " ";
        $ctrl.arrayStrSwipe = new Array(4);
        $ctrl.arrayStrSwipe = $ctrl.strCutUpSwipe.split("^");

        var sAccountNumber, sName, sShipToName, sMonth, sYear;

        if ($ctrl.arrayStrSwipe.length > 2) {
          $ctrl.paymentMethod.number = sAccountNumber = stripAlpha(
            arrayStrSwipe[0].substring(1, arrayStrSwipe[0].length)
          );
          $ctrl.paymentMethod.name = sName = arrayStrSwipe[1];
          $ctrl.paymentMethod.expirationMonth = sMonth = parseInt(
            arrayStrSwipe[2].substring(2, 4)
          );
          $ctrl.paymentMethod.expirationYear = sYear = parseInt(
            "20" + arrayStrSwipe[2].substring(0, 2)
          );

          //--- Different card swipe readers include or exclude the % in
          //--- the front of the track data - when it's there, there are
          //---   problems with parsing on the part of credit cards processor - so strip it off
          if ($ctrl.sTrackData.substring(0, 1) == "%") {
            $ctrl.track1 = $ctrl.sTrackData = $ctrl.sTrackData.substring(
              1,
              $ctrl.sTrackData.length
            );
          }

          //--- Add track 2 data to the string for processing reasons
          //        if (sTrackData.substring(sTrackData.length-1,1) != '?')  //--- Add a ? if not present
          //        { sTrackData = sTrackData + '?'; }
          $ctrl.track2 =
            ";" +
            sAccountNumber +
            "=" +
            sYear.substring(2, 4) +
            sMonth +
            "111111111111?";
          $ctrl.sTrackData = $ctrl.sTrackData + $ctrl.track2;

          //--- parse name field into first/last names
          var nameDelim = $ctrl.paymentMethod.name.indexOf("/");
          if (nameDelim != -1) {
            $ctrl.surname = $ctrl.paymentMethod.name.substring(0, nameDelim);
            $ctrl.firstname = $ctrl.paymentMethod.name.substring(nameDelim + 1);
            $ctrl.paymentMethod.name =
              trim($ctrl.firstname) + " " + trim($ctrl.surname);
          }
        }
      }

      //-----------------------------------------------------------------------------
      //--- Track 2 only cards
      //--- Ex: 1234123412341234=0305101193010877?
      //-----------------------------------------------------------------------------
      if ($ctrl.bTrack2) {
        //      alert('Track 2 swipe');

        nSeperator = strParse.indexOf("=");
        sCardNumber = strParse.substring(1, nSeperator);
        sYear = strParse.substr(nSeperator + 1, 2);
        sMonth = strParse.substr(nSeperator + 3, 2);

        // alert(sCardNumber + ' -- ' + sMonth + '/' + sYear);

        $ctrl.paymentMethod.number = sAccountNumber = stripAlpha(sCardNumber);
        $ctrl.paymentMethod.expirationMonth = sMonth = parseInt(sMonth);
        $ctrl.paymentMethod.expirationYear = sYear = parseInt("20" + sYear);

        //--- Different card swipe readers include or exclude the % in the front of the track data - when it's there,
        //---  there are problems with parsing on the part of credit cards processor - so strip it off
        if ($ctrl.sTrackData.substring(0, 1) == "%") {
          $ctrl.sTrackData = $ctrl.sTrackData.substring(
            1,
            $ctrl.sTrackData.length
          );
        }
      }

      //-----------------------------------------------------------------------------
      //--- No Track Match
      //-----------------------------------------------------------------------------
      if (!$ctrl.bTrack1_2 && !$ctrl.bTrack1 && !$ctrl.bTrack2) {
        //alert('Difficulty Reading Card Information.\n\nPlease Swipe Card Again.');
      }

      //    alert('Track Data: ' + document.formFinal.trackdata.value);

      //document.formFinal.trackdata.value = replaceChars(document.formFinal.trackdata.value,';','');
      //document.formFinal.trackdata.value = replaceChars(document.formFinal.trackdata.value,'?','');

      //    alert('Track Data: ' + document.formFinal.trackdata.value);
    } //--- end "if ( strParse != '' )"

    // this.dump = function(){
    // 	var s = "";
    // 	var sep = "\r"; // line separator
    // 	s += "Name: " + this.account_name + sep;
    // 	s += "Surname: " + this.surname + sep;
    // 	s += "first name: " + this.firstname + sep;
    // 	s += "account: " + this.account + sep;
    // 	s += "exp_month: " + this.exp_month + sep;
    // 	s += "exp_year: " + this.exp_year + sep;
    // 	s += "has track1: " + this.hasTrack1 + sep;
    // 	s += "has track2: " + this.hasTrack2 + sep;
    // 	s += "TRACK 1: " + this.track1 + sep;
    // 	s += "TRACK 2: " + this.track2 + sep;
    // 	s += "Raw Input Str: " + this.input_trackdata_str + sep;

    // 	return s;
    // }

    function stripAlpha(sInput) {
      if (sInput == null) return "";
      return sInput.replace(/[^0-9]/g, "");
    }
  }
}
